import { theme } from '@app/styles/theme'
import { css } from '@emotion/react'

export const page = css`
  position: absolute;
  inset: 0;
  top: 70px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #e7e7e7e7;

  ${theme.breakpoints.down('md')} {
    top: 56px;
  }
`

export const container = css`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #e7e7e7e7;
  overflow: hidden;
`

export const header = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 0;
  z-index: 10;
  flex-shrink: 0;

  ${theme.breakpoints.down('sm')} {
    min-height: 48px;
    padding: 0 12px;
  }
`

export const headerRight = css`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  ${theme.breakpoints.down('sm')} {
    gap: 6px;
  }
`

export const content = css`
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 1fr);

  ${theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    grid-template-rows: 42vh 1fr;
  }

  ${theme.breakpoints.down('sm')} {
    grid-template-rows: 36vh 1fr;
  }
`

export const mapPane = css`
  position: relative;
  min-height: 0;
  height: 100%;
  background: #e7e7e7e7;

  ${theme.breakpoints.down('md')} {
    min-height: 240px;
  }

  ${theme.breakpoints.down('sm')} {
    min-height: 200px;
  }
`

export const mapPlaceholder = css`
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 30% 20%, #ffffff 0%, #f6f6f6 35%, #f0f0f0 100%);
`

export const side = css`
  min-height: 0;
  overflow: auto;
  background: #e7e7e7e7;
  padding-bottom: 20px;
  -webkit-overflow-scrolling: touch;
`

export const sideInner = css`
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  h3 {
    margin-top: 48px;
    color: ${theme.palette.uintel.main};
    font-size: 18px;
    font-weight: 400;
  }
  padding: 18px 18px 28px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  ${theme.breakpoints.down('sm')} {
    padding: 14px 12px 24px;
    gap: 12px;
  }
`
